<script lang="ts">
	import { resetPage } from '../stores/filter';

	export let item: string;
	export let reset: CallableFunction;
</script>

<button
	on:click={() => {
		resetPage();
		reset();
	}}
	type="button">{item}</button
>
